import { render, staticRenderFns } from "./NewHome.vue?vue&type=template&id=4a493260&"
import script from "./NewHome.vue?vue&type=script&lang=ts&"
export * from "./NewHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports